import React, { createContext, useContext, useState, useCallback} from "react";
import {fetchStockLedger} from "../api/api";

const StockLedgerContext = createContext();

export const useStockLedger = () => useContext(StockLedgerContext);

export const StockLedgerProvider = ({children}) => {
    const [ledger, setLedger] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const loadLedger = useCallback(async (filters = {}, page = 1, pageSize = 20) => {
        setLoading(true);
        try {
            const response = await fetchStockLedger(filters, page, pageSize);
            setLedger(response.results || response);
            setTotalCount(response.count || 0);
        } catch (error) {
            console.error('Error fetching stock ledger:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    return (
        <StockLedgerContext.Provider value={{ledger, totalCount, loading, loadLedger}}>
            {children}
        </StockLedgerContext.Provider>
    );

}